import type { SnapshotOutOf } from "mobx-keystone";
import { ExtendedModel } from "mobx-keystone";
import { GlobalTModel } from "../../lib/models/global-t-model";
import { nsModel } from "../../lib/namespace";

const organizationNs = nsModel("organization");

@organizationNs.model
export default class OrganizationModel extends ExtendedModel(GlobalTModel, {}) {
  protected readonly omittedKeys: (keyof SnapshotOutOf<this>)[] = [];

  protected _setValueForKey<K extends keyof this["$"] & keyof this>(
    key: K,
    value: this[K],
  ): void {
    throw new Error("Method not implemented.");
  }
}
